import React from "react"
import { useSelector, useDispatch } from "react-redux"

import Images from "assets/images"
import { profileRoute } from "client/parts/routes"
import { StoreType, addModal } from "client/store"
import { Logo } from "client/components"

import { clearServerUserData } from "client/socketApi"

import {
    ProfileDropdown,
    ProfileDropdownItem,
    ProfileInfo,
    ProfileInfoName,
    ProfileInfoAccount,
} from "./styled"


const Profile = () => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const viewProfile = () => {
        dispatch(addModal({ url: profileRoute }))
    }

    const onSignOut = () => {
        clearServerUserData(userData.userId, userData.sessionId)
    }

    return (
        <ProfileDropdown title={([
            <Logo
                key="profile_logo"
                size={44}
                borderRadius={3}
                logo={userData.userLogo || Images.noAvatar}
            />,
            <ProfileInfo key="profile_info">
                <ProfileInfoName>{userData.userName}</ProfileInfoName>
                <ProfileInfoAccount>{userData.accountName}</ProfileInfoAccount>
            </ProfileInfo>,
        ])}
        >
            <ProfileDropdownItem onClick={viewProfile}>{lang.profile}</ProfileDropdownItem>
            <ProfileDropdownItem onClick={onSignOut}>{lang.signOut}</ProfileDropdownItem>
        </ProfileDropdown>
    )
}
export default Profile
